import { ModeleTheme, ModeleThemeWhithoutUpload } from '../constantes/publipostage/modele-theme';
import { ThemesFilter } from '../models/publipostage-modele/themes-by-source-modele';

export class ModeleUtils {
  static VIDE = '';
  static EMARGEMENTS = 'Emargements';
  static PARTICIPANTS = 'Participant';
  static FACTURES = 'Factures';
  static ATTESTATION_PARTICIPANT = 'Attestation Participant';
  static CONVENTION = 'Convention';
  static CONVOCATIONS_FORMATEURS = 'Convocations Formateurs';

  static getLibelleTheme(theme: ModeleTheme | ModeleThemeWhithoutUpload): string {
    const libellesThemes = {
      [ModeleTheme.Emargement]: this.EMARGEMENTS,
      [ModeleTheme.Participant]: this.PARTICIPANTS,
      [ModeleTheme.Factures]: this.FACTURES,
      [ModeleTheme.Convention]: this.CONVENTION,
      [ModeleTheme.ConvocationsFormateurs]: this.CONVOCATIONS_FORMATEURS,
    };
    return libellesThemes[theme];
  }

  static getThemesPublipostageSession(): ThemesFilter {
    return {
      Courrier: [ModeleTheme.Participant, ModeleTheme.Emargement, ModeleTheme.ConvocationsFormateurs],
      CourrierASigner: [ModeleTheme.ConvocationsFormateurs],
      Mail: [ModeleTheme.Participant, ModeleTheme.Factures, ModeleTheme.ConvocationsFormateurs],
    };
  }
  static getThemesPublipostageParcours(): ThemesFilter {
    return {
      Courrier: [ModeleTheme.Participant, ModeleTheme.Emargement, ],
      CourrierASigner: [],
      Mail: [ModeleTheme.Participant, ModeleTheme.Factures, ],
    };
  }
}
